import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePackageStore = defineStore('package', () => {
  const selectedStatusFilter = ref(null)
  
  function setStatusFilter(status) {
    console.log('Store: Setting status filter to:', status)
    selectedStatusFilter.value = status
    console.log('Store: Status filter is now:', selectedStatusFilter.value)
  }
  
  function clearFilters() {
    console.log('Store: Clearing filters, was:', selectedStatusFilter.value)
    selectedStatusFilter.value = null
    console.log('Store: Filters cleared, now:', selectedStatusFilter.value)
  }
  
  return {
    selectedStatusFilter,
    setStatusFilter,
    clearFilters
  }
}) 